import { useTranslation } from 'react-i18next';
import { UA_LANG } from 'components/langSwitcher/constants';

export const useGetButtonFontSize = (): string => {
    const { i18n } = useTranslation();
    if (i18n.language.includes(UA_LANG)) {
        return '0.7rem';
    }
    return '0.8rem';
};
